export function mapLocale(apiLocale) {
    const localeMap = {
      '-': 'defaultLocale',
      'zh-Hant': 'zhHant',
      'zh-Hans': 'zhHans',
    };
  
    return localeMap[apiLocale] || apiLocale;
  }